import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { Title} from '@angular/platform-browser';
import {filter, map} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ContactApiService} from '../../projects/api/src/contact/contact-api.service';
import {ContactInfo} from '../../projects/api/src/contact/contact-info.model';
import {BrandingApiService} from '../../projects/api/src/branding/branding-api.service';
import {ConfigApiService} from '../../projects/api/src/config/config-api.service';
import {LocaleService} from './shared/services/locale.service';
import {PrimeNGConfig} from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  favicon16Url = null;
  favicon32Url = null;
  faviconAppleTouchUrl = null;
  contactInfo: ContactInfo;
  private contactSubscription;

  constructor(public router: Router,
              private titleService: Title,
              private activatedRoute: ActivatedRoute,
              private brandingApi: BrandingApiService,
              private configApiService: ConfigApiService,
              private localeService: LocaleService,
              public translate: TranslateService,
              public primeNGConfig: PrimeNGConfig,
              private contactApi: ContactApiService) {

    this.contactSubscription = this.contactApi.getContactInfo()
      .subscribe(data => this.contactInfo = data);

      this.translate.stream('primeng').subscribe(data => {
        const locale = this.localeService.locale$.getValue();
        this.primeNGConfig.setTranslation(this.localeService.getCalendarLocale(locale.serverShort));
      });
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event => event instanceof NavigationEnd)),
      map(() => this.activatedRoute),
      map(route => {
        while (route && route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
    ).subscribe((route: any) => {
      const title = (this.contactInfo && this.contactInfo.appName && this.contactInfo.appName.trim().length > 0) ?
        this.contactInfo.appName : 'ATOMMIND SEMNEXT';
      if (route.data && route.data.value && route.data.value.title) {
        this.titleService.setTitle(`${this.translate.instant(route.data.value.title)} - ${title}`);
      } else {
        this.titleService.setTitle(title);
      }
    });

    this.setDefaultIcon16();
    this.setDefaultIcon32();
    this.setDefaultIcon168();
  }

  setDefaultIcon16() {
    let icon: any;
    icon = document.querySelector('#icon16');
    this.brandingApi.isExist('favicon16').subscribe(data => {
        if (data) {
          this.favicon16Url = this.brandingApi.makeImageUrl('favicon16');
        } else {
          this.favicon16Url = 'assets/static/misc/favicon-16x16.png';
        }
        icon.href = this.favicon16Url;
      }, error => {
        console.log(error);
        this.favicon16Url = 'assets/static/misc/favicon-16x16.png';
      }
    );
  }

  setDefaultIcon32() {
    let icon: any;
    icon = document.querySelector('#icon32');
    this.brandingApi.isExist('favicon32').subscribe(data => {
        if (data) {
          this.favicon32Url = this.brandingApi.makeImageUrl('favicon32');
        } else {
          this.favicon32Url = 'assets/static/misc/favicon-32x32.png';
        }
        icon.href = this.favicon32Url;
      }, error => {
        console.log(error);
        this.favicon32Url = 'assets/static/misc/favicon-32x32.png';
      }
    );
  }

  setDefaultIcon168() {
    let icon: any;
    icon = document.querySelector('#appleIcon');
    this.brandingApi.isExist('faviconAppleTouch').subscribe(data => {
        if (data) {
          this.faviconAppleTouchUrl = this.brandingApi.makeImageUrl('faviconAppleTouch');
        } else {
          this.faviconAppleTouchUrl = 'assets/static/misc/apple-touch-icon.png';
        }
        icon.href = this.faviconAppleTouchUrl;
      }, error => {
        this.faviconAppleTouchUrl = 'assets/static/misc/apple-touch-icon.png';
        console.log(error);
      }
    );
  }

  test() {
    return 1 + 1;
  }

  closePopup() {
    // Providing a `null` value to the named outlet
    // clears the contents of the named outlet
    this.router.navigate([{outlets: {modal: null}}]);
  }

  ngOnDestroy(): void {
    this.contactSubscription.unsubscribe();
  }

}
